import cn from 'classnames';
import LogoMark from '@/assets/images/Logo_TC_mark.svg?react';
import type { LogoProps } from '../types';

// Логотип telecom: знак + надпись «Telecom|Club» и «PARTNERS» под ней, как в
// макете (Claude Design, раздел 6 — вариант с выравниванием по левому краю).
// Надпись — текст шрифтом темы (Montserrat), а не картинка: так она остаётся
// резкой на любом размере и не требует отдельного файла под каждый масштаб.
//
// Все размеры в em от font-size корня, поэтому логотип масштабируется одним
// классом размера шрифта. База — сайдбар макета: надпись 19px, знак 34px,
// «PARTNERS» 7.5px. Белые части знака и надпись — currentColor (по умолчанию
// белый: логотип стоит на винном сайдбаре), серая дуга знака и «Club» — свои.
//
// min — только знак, цветом акцента: так логотип показан на светлом фоне шапки
// страницы в планшетной ширине, где белая надпись пропала бы.
//
// Кегли по макету: 'small' — 13.4px (панель и меню телефона), 'hero' — со
// страниц входа: 21px на телефоне, 27px на планшете, 29px на десктопе.
const SIZE_CLASS = {
  small: 'text-[13.4px]',
  default: 'text-[19px]',
  hero: 'text-[21px] sm:text-[27px] lg:text-[29px]',
} as const;

export const LogoImage = ({ min, size = 'default', className }: LogoProps) => {
  if (min) {
    return <LogoMark aria-label="TelecomClub Partners" className={cn('h-8 w-auto text-content-accent', className)} />;
  }

  return (
    <div
      role="img"
      aria-label="TelecomClub Partners"
      className={cn(
        'flex shrink-0 items-center gap-[0.358em] text-content-inverse',
        SIZE_CLASS[size],
        className,
      )}
    >
      <LogoMark className="h-[1.79em] w-auto shrink-0" />
      <div className="flex flex-col gap-[0.142em] font-app leading-none">
        <span className="whitespace-nowrap text-[1em] font-extrabold tracking-[-0.01em]">
          Telecom<span className="text-content-inverse-muted">Club</span>
        </span>
        <span className="pl-[0.037em] text-[0.395em] font-bold tracking-[0.12em]">PARTNERS</span>
      </div>
    </div>
  );
};
